import { merge } from 'lodash';
import html2pdf from 'html2pdf.js';
import { renderToString } from 'react-dom/server';

const BASE_CONFIG = {
  margin: [1, 0.5, 0.5, 0.5],
  filename: `${Date.now()}.pdf`,
  image: { type: 'jpeg', quality: 0.8 },
  html2canvas: { dpi: 75, scale: 2, letterRendering: true, useCORS: true },
  pagebreak: {
    mode: ['css', 'legacy', 'avoid-all'],
    avoid: ['img', 'tr', 'td', 'thead', 'table'],
  },
  jsPDF: {
    orientation: 'portrait',
    unit: 'in',
    format: 'a3',
    compressPDF: true,
    compress: true,
  },
  // pdfCallback: pdfCallback
};
export const getPDFBaseConfig = (overrideConfig) => {
  return merge(BASE_CONFIG, overrideConfig);
};

export const generatePDF = (config, template, header, footer) => {
  html2pdf()
    .from(renderToString(template))
    .set(config)
    .toPdf()
    .get('pdf')
    .then((pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        // set footer to every page
        pdf.setPage(i);
        // set footer font
        pdf.setFontSize(10);
        pdf.setTextColor(150);
        pdf.setLineWidth(0.1);
        header(pdf);
        footer(pdf, i, totalPages);
      }
    })
    .save()
    .catch((error) => {});
};

export const generateSimplePDF = (elId, config, cb) => {
  const element = document.getElementById(elId);
  element.classList.add('exporting');
  if (elId) {
    html2pdf()
      .from(element)
      .set(getPDFBaseConfig(config || {}))
      .save()
      .then(() => {
        element.classList.remove('exporting');
        if (cb) cb();
      });
  }
};
